import React from "react";
import { AiOutlineClose, AiOutlineMenu } from "react-icons/ai";
import { useEffect, useState } from "react";
import { client } from "../client";
// import { motion } from "framer-motion";

function Navbar() {
    const [isScrolled, setIsScrolled] = useState(false);
    const [toggle, setToggle] = useState(false);

    const navbarList = [
        "home",
        "skills",
        "experience",
        "projects",
        "achievements",
        "about",
        "resume",
    ]

    const [resume, setResumePDF] = useState([]);

    useEffect(() => {
        const query = '*[_type == "resume"]';

        client.fetch(query).then((resume) => setResumePDF(resume));
    }, []);

    useEffect(() => {
        const handleScroll = () => {
            if (window.scrollY > 0) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        window.addEventListener("scroll", handleScroll);

        return () => {
            window.removeEventListener("scroll", handleScroll);
        };
    }, []);
    return (
        <nav>
            <div
                className={`${isScrolled
                    ? "bg-gray-800 backdrop-blur-sm shadow-md bg-opacity-40 "
                    : "nav"
                    } fixed  top-0 w-full p-2 z-50 flex justify-between items-center rounded-b-xl `}>
                <a href="#home">
                    <div className="Logo font-bold font-face-p text-transparent w-min text-4xl md:text-5xl bg-clip-text bg-gradient-to-r from-red-500 to-yellow-500">
                        Shubhankar
                    </div>
                </a>

                <ul className="hidden md:flex justify-between items-center ">
                    {navbarList.map((item) => (
                        <li key={`link-${item}`} className="m-3 ">
                            {item === "resume" ? (
                                <a
                                    href={resume[0]?.resumeLink}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="font-bold text-red-600 hover:text-red-500 hover:underline underline-offset-8 uppercase transition duration-300 ease-in-out ">
                                    Resume
                                </a>
                            ) : (
                                <a
                                    href={`#${item}`}
                                    className="font-medium text-gray-300 hover:text-red-500 hover:underline underline-offset-8 uppercase transition duration-300 ease-in-out ">
                                    {item}
                                </a>
                            )}
                        </li>
                    ))}
                </ul>
            </div>
            <div className="md:hidden fixed top-0 right-0 !z-50 justify-center items-center">
                {toggle ? (
                    <div
                        id="menuContainer"
                        className="fixed top-0 right-0 !z-50 !rounded-lg !bg-gray-800 !bg-opacity-60 !backdrop-blur-md !shadow-lg !shadow-black/30">
                        <AiOutlineClose
                            onClick={() => setToggle(false)}
                            className="fixed top-0 right-0 m-5 text-red-500 hover:text-red-800"
                        />
                        <ul className="m-4 mt-10 ">
                            {navbarList.map((item) => (
                                <li key={item} className="m-2">
                                    {item === "resume" ? (
                                        <a
                                            href={resume[0]?.resumeLink}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="font-bold text-red-600 hover:text-red-500 hover:underline underline-offset-8 uppercase transition duration-300 ease-in-out ">
                                            Resume
                                        </a>
                                    ) : (
                                        <a
                                            href={`#${item}`}
                                            className="font-medium text-gray-300 hover:text-red-500 hover:underline underline-offset-8 uppercase transition duration-300 ease-in-out ">
                                            {item}
                                        </a>
                                    )}
                                </li>
                            ))}
                        </ul>
                    </div>
                ) : (
                    <AiOutlineMenu
                        onClick={() => setToggle(true)}
                        className=" m-5 text-red-500 hover:text-red-800"
                    />
                )}
            </div>
        </nav>
    );
}

export default Navbar;
